import React from 'react';
import clsx from 'clsx';
import { AText, Box, Button } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';
import { Image } from '@namespace/icons2';
import { useHistory } from '@namespace/router';
import { useGetGameLaunchError } from '../../../hooks';
import { IGameErrorProps } from './types';

import styles from './index.module.css';

export const GameError: React.FC<IGameErrorProps> = ({ errorCode }) => {
  const { t } = useI18n();
  const { push } = useHistory();
  const errorData = useGetGameLaunchError(errorCode);
  const { errorTextTranslationKey, linkTo, linkTextTranslationKey } = errorData;

  return (
    <Box
      direction="column"
      align="center"
      justify="center"
      className={clsx([styles.wrapper])}
    >
      <Image name="general/folder_with_chain" className={styles.image} alt="" />
      <AText className={clsx([styles.text])} breed="BU" align="center">
        {t(errorTextTranslationKey)}
      </AText>

      {linkTo && (
        <Box className={styles.buttonLinkWrapper}>
          <Button
            onClick={() => push(linkTo)}
            intent="secondary"
            actionType="color3"
            size="s"
          >
            {t(linkTextTranslationKey)}
          </Button>
        </Box>
      )}
    </Box>
  );
};
